import { FadeLens } from "./types/FadeLens";
import { HighlightLens } from "./types/HighlightLens";

export const LensTypes = Object.freeze({

    for(type: string) {
        if (type === 'fade') {
            return FadeLens;
        }
        if (type === 'highlight') {
            return HighlightLens;
        }
        return null;
    }

});